"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkTreeNode = exports.getFilteredExpandedIds = exports.getDefaultExpandedIds = exports.getNodeShowState = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var TreeNode_1 = require("./TreeNode");
var is_child_of_type_1 = require("../_util/is-child-of-type");
function getNodeShowState(id, relations, expandedIds, isFiltered) {
    // 留存源id
    var originId = id;
    var show = true;
    var nodeSet = new Set();
    while (relations[id] && !nodeSet.has(relations[id])) {
        nodeSet.add(relations[id]);
        if (!expandedIds.includes(relations[id])) {
            show = false;
            break;
        }
        // eslint-disable-next-line no-param-reassign
        id = relations[id];
    }
    // 兼容过滤操作
    if (!expandedIds.includes(originId) && !isFiltered) {
        show = false;
    }
    return show;
}
exports.getNodeShowState = getNodeShowState;
function getDefaultExpandedIds(_a) {
    var relations = _a.relations, expandedIds = _a.expandedIds, defaultExpandedIds = _a.defaultExpandedIds, defaultExpandAll = _a.defaultExpandAll, _b = _a.defaultExpandParent, defaultExpandParent = _b === void 0 ? true : _b, forceExpandParent = _a.forceExpandParent;
    // 受控
    if (Array.isArray(expandedIds)) {
        return expandedIds;
    }
    if (defaultExpandAll) {
        var ids_1 = [];
        Object.values(relations).forEach(function (parent) {
            ids_1.push(parent);
        });
        return ids_1;
    }
    var expandParent = forceExpandParent !== null && forceExpandParent !== void 0 ? forceExpandParent : defaultExpandParent;
    if (expandParent) {
        var idSet_1 = new Set(defaultExpandedIds);
        defaultExpandedIds.forEach(function (id) {
            var child = id;
            while (child in relations && !idSet_1.has(relations[child])) {
                idSet_1.add(relations[child]);
                child = relations[child];
            }
        });
        return tslib_1.__spread(idSet_1);
    }
    return defaultExpandedIds;
}
exports.getDefaultExpandedIds = getDefaultExpandedIds;
/**
 * 获取被过滤后需展开的节点集合
 * @param nodes 树节点集合
 * @param relations 父子节点对应关系
 * @returns
 */
function getFilteredExpandedIds(nodes, relations) {
    if (!nodes.length)
        return [];
    var idSet = new Set();
    tslib_1.__spread(nodes).reverse().forEach(function (node) {
        // 获取父节点
        var parent = relations[node.id];
        if (node.isFiltered || idSet.has(node.id)) {
            if (parent) {
                idSet.add(parent);
            }
            else {
                idSet.add(node.id);
            }
        }
    });
    return tslib_1.__spread(idSet);
}
exports.getFilteredExpandedIds = getFilteredExpandedIds;
/**
 * 新的平级结构无法适配原有自定义 Node 组件嵌套
 * 判断如果包含自定义组件则使用老版本组件渲染
 */
function checkTreeNode(children) {
    var isValid = true;
    if (!children) {
        return isValid;
    }
    react_1.default.Children.forEach(children, function (child) {
        if (react_1.isValidElement(child)) {
            if (isValid) {
                if (!is_child_of_type_1.isChildOfType(child, TreeNode_1.TreeNode)) {
                    isValid = false;
                }
                else {
                    isValid = checkTreeNode(child.props.children);
                }
            }
        }
    });
    return isValid;
}
exports.checkTreeNode = checkTreeNode;
//# sourceMappingURL=util.js.map